import React, { useCallback, useState, useEffect, useMemo } from "react";
import SnackbarUtils from "../../../../../../../libs/SnackbarUtils";
import { serviceGetList } from "../../../../../../../services/Common.service";
import { serviceGetEmployeeList } from "../../../../../../../services/Chat.service";
import constants from "../../../../../../../config/constants";
import RolesUtils from "../../../../../../../libs/Roles.utils";
import { useSelector } from "react-redux";

const fieldkeys = {
  GRADES: "grade_ids",
  DESIGNATIONS: "designation_ids",
  ZONES: "zone_ids",
  STATES: "state_ids",
  HQS: "hq_ids",
  LOCATIONS: "location_ids",
  DEPARTMENTS:"department_ids"
};
const useAddEmployeeTable = ({ handleClose, editEmployee }) => {
  const [selected, setSelected] = useState([]);
  const [allData, setAllData] = useState([]);
  const [form, setForm] = useState({
    filtered_by: "",
    type: [],
  });
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [currentData, setCurrentData] = useState([]);
  const [isDialog, setIsDialog] = useState(false);
  const [isFetching, setIsFetching] = useState(false);
  const { role } = useSelector((state) => state.auth);
  const [listData, setListData] = useState({
    GRADES: [],
    DESIGNATIONS: [],
    ZONES: [],
    HQS: [],
    LOCATIONS: [],
    DEPARTMENTS:[],
    STATES: [],
  });

  const totalShow = 10;

  useEffect(() => {
    serviceGetList([
      "GRADES",
      "ZONES",
      "DESIGNATIONS",
      "HQS",
      "LOCATIONS",
      "DEPARTMENTS",
      "STATES",
    ]).then((res) => {
      if (!res.error) {
        setListData(res.data);
      }
    });
  }, []);

  const isShowFilter = useMemo(() => {
    const Roles = constants.ROLES;
    return RolesUtils.canAccess([Roles.CORPORATE_HR], role);
  }, [role]);

  const renderEmployeeList = useCallback(
    (data = {}) => {
      const ids = data?.type?.map((val) => val?.id) || [];
      const filterKey = fieldkeys?.[data?.filtered_by];

      const fetchList = (params = {}) => {
        setIsFetching(true);
        serviceGetEmployeeList(params)
          .then((res) => {
            const list = !res?.error && res?.data ? res.data : [];
            setAllData(list);
            setData(list);
            setCurrentPage(1);
          })
          .finally(() => {
            setIsFetching(false);
          });
      };

      if (filterKey && ids.length) {
        fetchList({ [filterKey]: ids });
      } else if (!isShowFilter) {
        fetchList();
      } else {
        setAllData([]);
        setData([]);
        setCurrentPage(1);
        setIsFetching(false);
      }
    },
    [isShowFilter, setIsFetching]
  );

  useEffect(() => {
    if (editEmployee?.employees?.length > 0) {
      setSelected(editEmployee?.employees);
      const fd = {
        filtered_by: editEmployee?.filtered_by ?? "",
        type: editEmployee?.type ?? [],
      };
      setForm({ ...fd });
      renderEmployeeList({ ...fd });
    } else if (!isShowFilter) {
      renderEmployeeList();
    }
  }, [editEmployee, isShowFilter]);

  useEffect(() => {
    _processData();
  }, [currentPage, data]);

  const changeTextData = useCallback(
    (text, fieldName) => {
      const t = { ...form };
      if (fieldName === "filtered_by") {
        t["type"] = [];
        setAllData([]);
        setData([]);
        setSelected([]);
      }
      t[fieldName] = text;
      if (fieldName === "type") {
        renderEmployeeList(t);
      }
      setForm(t);
    },
    [form, renderEmployeeList]
  );
  useEffect(() => {
    if(!editEmployee?.employees?.length > 0){
      if (allData?.length > 0 && selected?.length > 0) {
      const filtered = selected.filter((sel) =>
        allData.some((data) => data.id === sel.id)
      );
      setSelected(filtered);
    } else if (allData?.length === 0) {
      setSelected([]);
    }
    }
  }, [allData, form?.type]);

  const _processData = () => {
    const from = currentPage * totalShow - totalShow;
    let to = currentPage * totalShow;
    if (from <= data.length) {
      to = to <= data.length ? to : data.length;
      setCurrentData(data.slice(from, to));
    }
  };

  const handlePageChange = useCallback(
    (type) => {
      console.log("_handlePageChange", type);
      if (Math.ceil(data.length / totalShow) >= type + 1) {
        setCurrentPage(type + 1);
      }
    },
    [data, totalShow]
  );

  const queryFilter = useCallback((key, value) => {
    console.log("_queryFilter", key, value);
  }, []);

  const handleFilterDataChange = useCallback(
    (value) => {
      console.log("_handleFilterDataChange", value);
      queryFilter("FILTER_DATA", value);
    },
    [queryFilter]
  );

  const handleSearchValueChange = useCallback(
    (value) => {
      console.log("_handleSearchValueChange", value);
      queryFilter("SEARCH_TEXT", value);
      let tempData = allData;
      if (value) {
        tempData = allData.filter((val) => {
          return (
            val?.emp_code?.match(new RegExp(value, "ig")) ||
            val?.name?.match(new RegExp(value, "ig"))
          );
        });
      }

      setCurrentPage(1);
      setData(tempData);
    },
    [queryFilter, allData]
  );

  const handleSortOrderChange = useCallback((row, order) => {
    console.log(`handleSortOrderChange key:${row} order: ${order}`);
  }, []);

  const handleRowSize = (page) => {
    console.log(page);
  };

  const handleRowSelection = (page) => {
    console.log(">>>>>>>", page);
  };

  const handleCheckbox = useCallback(
    (data) => {
      const tempSelected = JSON.parse(JSON.stringify(selected));
      const tempIndex = tempSelected.findIndex((sel) => sel.id === data.id);
      if (tempIndex >= 0) {
        tempSelected.splice(tempIndex, 1);
      } else {
        tempSelected.push(data);
      }
      setSelected(tempSelected);
    },
    [selected]
  );
  const selectAllEmployee = useCallback(
    (e) => {
      if (e.target.checked) {
        setSelected(allData);
      } else {
        setSelected([]);
      }
    },
    [selected, setSelected, allData]
  );

  return {
    handlePageChange,
    handleFilterDataChange,
    handleSearchValueChange,
    handleRowSize,
    handleSortOrderChange,
    handleCheckbox,
    selected,
    currentPage,
    currentData,
    data,
    allData,
    isFetching,
    isDialog,
    handleRowSelection,
    form,
    changeTextData,
    listData,
    isShowFilter,
    selectAllEmployee,
  };
};

export default useAddEmployeeTable;
